import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c48b8060&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c48b8060&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/liando-portal_pdr2/dyc-portal-pc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c48b8060')) {
      api.createRecord('c48b8060', component.options)
    } else {
      api.reload('c48b8060', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c48b8060&", function () {
      api.rerender('c48b8060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frame/index.vue"
export default component.exports